import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTWCL_If_you_choose_to_make_this_you_ELL,
  TXTWCL_Learn_more_XaXhereX_aXX,
  TXTWCL_You_will_still_be_able_to_choo_ELL
} from './HelpSectionContent.messages.json';

const HelpSectionContent: React.FC = () => (
  <>
    <Translation {...TXTWCL_If_you_choose_to_make_this_you_ELL} />{' '}
    <Translation {...TXTWCL_You_will_still_be_able_to_choo_ELL} />{' '}
    <Translation
      values={{
        a: (msg: string) => (
          <ResolverLink resolverTag={ResolverTag.HelpCenterDepositDeletingUpdatingCardDetails}>
            {msg}
          </ResolverLink>
        )
      }}
      {...TXTWCL_Learn_more_XaXhereX_aXX}
    />
  </>
);

export default HelpSectionContent;
